module.exports = __webpack_public_path__ + "4ae15fc583c9221067f44d9a9b709ba0.fbx";